<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{data?.title}}</h3>
			</div>
			<div class="zesty-modal__content">
				<br>
				<mat-form-field class="w-100">
					<mat-label>Organization name:</mat-label>
					<input matInput [formControl]="inputName">
				</mat-form-field>
			</div>
			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button class="zesty-modal__create-btn"
								[disabled]="inputName.invalid || isLoading"
								(click)="save()">Save</button>
			</div>
		</div>
	</div>
</div>
